/**
 * @generated SignedSource<<13e2e49c84796ee29f44b92e614bffa9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EnrollmentStatus = "ACTIVE" | "PAST" | "UPCOMING" | "%future added value";
export type ClientProgramListRouteQuery$variables = {
  status: EnrollmentStatus;
};
export type ClientProgramListRouteQuery$data = {
  readonly enrollments: {
    readonly " $fragmentSpreads": FragmentRefs<"Programs_enrollments">;
  } | null | undefined;
  readonly me: {
    readonly enrollmentsStatus: {
      readonly active: number;
      readonly past: number;
      readonly upcoming: number;
    };
  } | null | undefined;
};
export type ClientProgramListRouteQuery = {
  response: ClientProgramListRouteQuery$data;
  variables: ClientProgramListRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "EnrollmentsStatusType",
  "kind": "LinkedField",
  "name": "enrollmentsStatus",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "past",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "upcoming",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "utc",
  "value": true
},
v5 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MMM DD, YYYY"
  },
  (v4/*: any*/)
],
v6 = {
  "kind": "Literal",
  "name": "componentType",
  "value": "LESSON"
},
v7 = {
  "kind": "Literal",
  "name": "endWeek",
  "value": 0
},
v8 = {
  "kind": "Literal",
  "name": "startWeek",
  "value": -5
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Completion",
    "kind": "LinkedField",
    "name": "completion",
    "plural": false,
    "selections": [
      (v9/*: any*/)
    ],
    "storageKey": null
  }
],
v11 = {
  "kind": "Literal",
  "name": "componentType",
  "value": "HABIT"
},
v12 = {
  "kind": "Literal",
  "name": "period",
  "value": "LAST_7_DAYS"
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v15 = [
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "total",
    "storageKey": null
  },
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Completion",
  "kind": "LinkedField",
  "name": "completion",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientProgramListRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "enrollments",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Programs_enrollments"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientProgramListRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "enrollments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Program",
                    "kind": "LinkedField",
                    "name": "program",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageURL",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalDays",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": "endDate(format:\"MMM DD, YYYY\",utc:true)"
                  },
                  {
                    "alias": "lessonsByWeeks",
                    "args": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "concreteType": "CompletionByWeek",
                    "kind": "LinkedField",
                    "name": "completionByWeeks",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": "completionByWeeks(componentType:\"LESSON\",endWeek:0,startWeek:-5)"
                  },
                  {
                    "alias": "habitsByWeeks",
                    "args": [
                      (v11/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "concreteType": "CompletionByWeek",
                    "kind": "LinkedField",
                    "name": "completionByWeeks",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": "completionByWeeks(componentType:\"HABIT\",endWeek:0,startWeek:-5)"
                  },
                  {
                    "alias": "checkinsByWeeks",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "componentType",
                        "value": "CHECKIN"
                      },
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "concreteType": "CompletionByWeek",
                    "kind": "LinkedField",
                    "name": "completionByWeeks",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": "completionByWeeks(componentType:\"CHECKIN\",endWeek:0,startWeek:-5)"
                  },
                  {
                    "alias": "completion7Days",
                    "args": (v13/*: any*/),
                    "concreteType": "Completion",
                    "kind": "LinkedField",
                    "name": "completion",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/)
                    ],
                    "storageKey": "completion(period:\"LAST_7_DAYS\")"
                  },
                  {
                    "alias": "lessons7Days",
                    "args": [
                      (v6/*: any*/),
                      (v12/*: any*/)
                    ],
                    "concreteType": "Completion",
                    "kind": "LinkedField",
                    "name": "completion",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": "completion(componentType:\"LESSON\",period:\"LAST_7_DAYS\")"
                  },
                  {
                    "alias": "habits7Days",
                    "args": [
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "concreteType": "Completion",
                    "kind": "LinkedField",
                    "name": "completion",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": "completion(componentType:\"HABIT\",period:\"LAST_7_DAYS\")"
                  },
                  {
                    "alias": "completionByDate7Days",
                    "args": (v13/*: any*/),
                    "concreteType": "CompletionByDate",
                    "kind": "LinkedField",
                    "name": "completionByDate",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": null
                      },
                      (v16/*: any*/)
                    ],
                    "storageKey": "completionByDate(period:\"LAST_7_DAYS\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "username",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "startFromNow",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "format",
                        "value": "fromNow"
                      },
                      (v4/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": "startDate(format:\"fromNow\",utc:true)"
                  },
                  {
                    "alias": "endDateShort",
                    "args": (v5/*: any*/),
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": "endDate(format:\"MMM DD, YYYY\",utc:true)"
                  },
                  {
                    "alias": "endDateLong",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "format",
                        "value": "MMMM D, YYYY"
                      },
                      (v4/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": "endDate(format:\"MMMM D, YYYY\",utc:true)"
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "748ac816f62f1c0a32c720f3e38c3079",
    "id": null,
    "metadata": {},
    "name": "ClientProgramListRouteQuery",
    "operationKind": "query",
    "text": "query ClientProgramListRouteQuery(\n  $status: EnrollmentStatus!\n) {\n  enrollments(status: $status) {\n    ...Programs_enrollments\n  }\n  me {\n    enrollmentsStatus {\n      active\n      past\n      upcoming\n    }\n    id\n  }\n}\n\nfragment ClientLast7DaysCompletion_completionByDate on CompletionByDate {\n  date\n  completion {\n    completed\n    total\n    rate\n  }\n}\n\nfragment ClientLast7Days_enrollment on Enrollment {\n  completion7Days: completion(period: LAST_7_DAYS) {\n    rate\n  }\n  lessons7Days: completion(period: LAST_7_DAYS, componentType: LESSON) {\n    completed\n    total\n    rate\n  }\n  habits7Days: completion(period: LAST_7_DAYS, componentType: HABIT) {\n    completed\n    total\n    rate\n  }\n  completionByDate7Days: completionByDate(period: LAST_7_DAYS) {\n    ...ClientLast7DaysCompletion_completionByDate\n  }\n}\n\nfragment ClientPastProgramCard_enrollment on Enrollment {\n  ...ClientSmallProgramCard_enrollment\n  totalDays\n  endDateLong: endDate(utc: true, format: \"MMMM D, YYYY\")\n  completion {\n    completed\n    total\n    rate\n  }\n}\n\nfragment ClientProgramActivity_enrollment on Enrollment {\n  lessonsByWeeks: completionByWeeks(componentType: LESSON, startWeek: -5, endWeek: 0) {\n    startDate\n    completion {\n      completed\n    }\n  }\n  habitsByWeeks: completionByWeeks(componentType: HABIT, startWeek: -5, endWeek: 0) {\n    startDate\n    completion {\n      completed\n    }\n  }\n  checkinsByWeeks: completionByWeeks(componentType: CHECKIN, startWeek: -5, endWeek: 0) {\n    startDate\n    completion {\n      completed\n    }\n  }\n}\n\nfragment ClientProgramProgressCard_enrollment on Enrollment {\n  program {\n    name\n    imageURL\n    slug\n    id\n  }\n  currentDay\n  totalDays\n  endDate(utc: true, format: \"MMM DD, YYYY\")\n  ...ClientProgramActivity_enrollment\n  ...ClientLast7Days_enrollment\n}\n\nfragment ClientSmallProgramCard_enrollment on Enrollment {\n  program {\n    name\n    imageURL\n    slug\n    id\n  }\n  client {\n    username\n    id\n  }\n}\n\nfragment ClientUpcomingProgramCard_enrollment on Enrollment {\n  ...ClientSmallProgramCard_enrollment\n  totalDays\n  startFromNow: startDate(utc: true, format: \"fromNow\")\n  endDateShort: endDate(utc: true, format: \"MMM DD, YYYY\")\n}\n\nfragment Programs_enrollments on EnrollmentConnection {\n  edges {\n    node {\n      id\n      ...ClientProgramProgressCard_enrollment\n      ...ClientUpcomingProgramCard_enrollment\n      ...ClientPastProgramCard_enrollment\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "958fc66055d30137c831e6b497153a71";

export default node;
